// This file is excluded from the localization check

import { getCurrentLanguage } from 'locale'
import { snakeToCamel } from 'containers/ClanManagement/proxy/helpers'

export const localizedLanguageTitles = {
    az: 'Azərbaycanca',
    be: 'Беларуская',
    bg: 'Български',
    bs: 'Bosanski',
    cs: 'Čeština',
    da: 'Dansk',
    de: 'Deutsch',
    el: 'Ελληνικά',
    en: 'English',
    es: 'Español',
    et: 'Eesti',
    fi: 'suomi',
    fil: 'Filipino',
    fr: 'Français',
    hr: 'Hrvatski',
    hu: 'Magyar',
    hy: 'հայերեն',
    id: 'Bahasa Indonesia',
    it: 'Italiano',
    ja: '日本語',
    ka: 'ქართული',
    kk: 'Қазақша',
    ko: '한국어',
    ky: 'Кыргызча',
    lt: 'Lietuvių',
    lv: 'Latviešu',
    mo: 'Молдовеняскэ',
    ms: 'Bahasa Melayu',
    nl: 'Nederlands',
    no: 'Norsk',
    pl: 'Polski',
    pt: 'Português',
    ro: 'Română',
    ru: 'Русский',
    sk: 'Slovenčina',
    sq: 'Shqip',
    sr: 'Srpski',
    sv: 'Svenska',
    tg: 'Тоҷикӣ',
    th: 'ภาษาไทย',
    tk: 'Türkmençe',
    tr: 'Türkçe',
    uk: 'Українська',
    uz: 'Oʻzbekcha',
    vi: 'Tiếng Việt',
    zh: '繁體中文',
    zh_CN: '简体中文',
}

export const languageCodesByRealm = {
    ru: ['az', 'be', 'et', 'hy', 'ka', 'kk', 'ky', 'lt', 'lv', 'mo', 'ru', 'tg', 'tk', 'uk', 'uz'],
    eu: [
        'az', 'be', 'bg', 'bs', 'cs', 'da', 'de', 'el', 'en', 'es',
        'et', 'fi', 'fr', 'hr', 'hu', 'hy', 'it', 'ka', 'kk', 'ky', 'lt', 'lv',
        'mo', 'nl', 'no', 'pl', 'pt', 'ro', 'ru', 'sk',
        'sq', 'sr', 'sv', 'tg', 'tk', 'tr', 'uk', 'uz',
    ],
    na: ['en', 'es', 'pt'],
    asia: ['en', 'fil', 'id', 'ja', 'ko', 'ms', 'th', 'vi', 'zh'],
    cn360: ['zh'],
}

export const getDefaultLanguageCode = () => {
    const langCodes = Object.keys(localizedLanguageTitles)
    const browserLangCode = getCurrentLanguage().split('-')[0]
    return langCodes.includes(browserLangCode) ? browserLangCode : 'en'
}

export const getItemsForLanguageSelect = (realm, fallbackLangCode) => {
    const langCodes = languageCodesByRealm[realm] || [fallbackLangCode]
    return langCodes
        .map((langCode) => {
            // only cn360 realm will use zh_CN lang, but send to BE 'zh' string as language
            const caption = (realm === 'cn360') ?
                localizedLanguageTitles['zh_CN'] :
                localizedLanguageTitles[langCode]

            return {
                value: langCode,
                caption,
            }
        })
        .sort((a, b) => a.caption.localeCompare(b.caption))
}

export const numberToHexString = (number) => {
    number = number.toString(16)
    const padding = '000000'.slice(number.length)
    return `#${padding}${number}`
}

export const prepareClanData = (initialData) => {
    if (!Array.isArray(initialData)) {
        return initialData
    }
    return initialData.map((arrayItem) => {
        const result = {}
        for (let key of Object.keys(arrayItem)) {
            result[snakeToCamel(key)] = arrayItem[key]
        }

        if (Number.isInteger(result.color)) {
            result.color = numberToHexString(result.color)
        }
        if (result.emblems && result.emblems['32x32']) {
            result.emblem = result.emblems['32x32']
        }
        if (result.recruitingPolicy) {
            result.isRecruitingOpened = result.recruitingPolicy === 'open'
        }
        if (result.languages) {
            result.languages = result.languages.map((language) => (language === 'tl' ? 'fil' : language))
        }
        return result
    })
}



// WEBPACK FOOTER //
// ./state/actions/helpers/recommended_clans.js